import { connect } from 'react-redux'
import Delivery from './Delivery'

const mapStateToProps = () => ({ color: '#d80417' })

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Delivery)
